import { List } from 'immutable'
import * as actions from './actions'
import Company from './Company'
import { Record } from '../transit'
import { ListMeta } from '../lib/redux-lists'

const State = Record({
  meta: new ListMeta(),
  all: new List(),
  current: new Company(),
}, 'companies')

const companiesReducer = (state = new State(), action) => {
  switch (action.type) {
    case actions.COMPANIES_LOAD_SUCCESS: {
      const companies = List(action.payload.data.map(json => new Company(json)))
      return state.set('all', companies).set('meta', new ListMeta(action.payload.meta))
    }
    case actions.COMPANIES_ALL_LOAD_SUCCESS: {
      const companies = List(action.payload.data.map(json => new Company(json)))
      return state.set('all', companies).set('meta', new ListMeta(action.payload.meta))
    }
    case actions.COMPANY_LOAD_SUCCESS: {
      const company = new Company(action.payload.data)
      return state.set('current', company)
    }
    case actions.COMPANY_CREATE_SUCCESS: {
      const company = new Company(action.payload.data)
      return state.set('current', company)
    }
    case actions.COMPANY_UPDATE_SUCCESS: {
      const company = new Company(action.payload.data)
      return state.set('current', company)
    }
    case actions.COMPANY_DELETE_SUCCESS: {
      const list = state.get('all')
      const { _id } = action.payload.data
      const index = list.findIndex((item) => item._id === _id)
      return state.set('all', list.remove(index))
    }
    case actions.CLEAR_COMPANIES: {
      return state.set('all', new List()).set('meta', new ListMeta())
    }
    case actions.CLEAR_COMPANY: {
      return state.set('current', new Company())
    }
    default:
      return state
  }
}

export default companiesReducer



// WEBPACK FOOTER //
// ./src/common/companies/reducer.js